import { WidgetThemeCustomDto } from '@/Domain/api/WIdget/dto/WidgetTheme.dto';

// Keep in sync with the Pydantic source of truth in
// `appquickchat.api.widget.widget_theme_schemas.WidgetThemeCustom`, which the
// model field default and migration backfill both derive from.
export const DEFAULT_WIDGET_THEME_CUSTOM: WidgetThemeCustomDto = {
  colors: {
    background: '#ffffff',
    header: '#ffffff',
    header_text: '#030712',
    accent: '#27272a',
    accent_hover: '#374151',
    accent_text: '#ffffff',
    bubble: '#27272a',
    bubble_text: '#ffffff',
    ai_bubble_text: '#030712',
    tertiary: '#afafb2',
    link: null,
    input_background: '#ffffff',
    input_text: '#030712',
    input_placeholder: '#9ca3af',
    border: '#e5e7eb',
    sidebar: {
      background: '#f5f5f5',
      text: null,
      accent: '#e5e5e5',
      accent_text: null,
    },
  },
  radius: { bubble: 'full', input: 'full', button: 'full' },
  font: { size: 'base' },
};
